import { WorkerList } from 'hq/services/flex-worker-service.types';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { AutocompleteOption, Header, Page, Toolbox } from 'redesign';
import {
  AccreditationForm,
  AccreditationFormTypes,
  CertificateWithFileUrl,
} from 'shared/components/forms/accreditation-form/accreditation-form';
import { EmployeeCertificateAddToolbox } from './employee-certificate-add-toolbox';

type Props = {
  certificates: CertificateWithFileUrl[];
  flexWorkers: WorkerList[];
  flexWorkerOption: AutocompleteOption | null;
};

export const EmployeeCertificateAddPage = ({
  certificates,
  flexWorkers,
  flexWorkerOption,
}: Props) => {
  const [flexWorkerSearch, setFlexWorkerSearch] = useState<string>(flexWorkerOption?.label ?? '');
  const [flexWorkerSelectedOption, setFlexWorkerSelectedOption] =
    useState<AutocompleteOption | null>(flexWorkerOption);

  const formMethods = useForm<AccreditationFormTypes>({
    defaultValues: {
      files: [],
      accreditationType: null,
      certificate: null,
      startDate: null,
      expirationDate: null,
      flexWorkerOption: flexWorkerOption,
      isWithoutDocument: false,
      hasPreviouslyUploadedDocument: false,
    },
  });

  useEffect(() => {
    if (flexWorkerOption) {
      setFlexWorkerSelectedOption(flexWorkerOption);
      setFlexWorkerSearch(flexWorkerOption.label);
    }
  }, [flexWorkerOption]);

  useEffect(() => {
    if (flexWorkerSelectedOption) {
      formMethods.setValue('flexWorkerOption', flexWorkerSelectedOption);
    }
  }, [flexWorkerSelectedOption, formMethods]);

  return (
    <FormProvider {...formMethods}>
      <Page
        header={<Header titleText="Certificaat toevoegen" />}
        toolbox={
          <Toolbox>
            <EmployeeCertificateAddToolbox />
          </Toolbox>
        }
      >
        <AccreditationForm
          certificates={certificates}
          formState="create"
          flexWorkerOption={flexWorkerSelectedOption}
          flexWorkerSearch={flexWorkerSearch}
          setFlexWorkerSearch={setFlexWorkerSearch}
          setFlexWorkerOption={setFlexWorkerSelectedOption}
          flexWorkerDisabled={true}
          flexWorkers={flexWorkers}
        />
      </Page>
    </FormProvider>
  );
};
